import { render, staticRenderFns } from "./LoginSelector.vue?vue&type=template&id=48cebba2&scoped=true"
import script from "./LoginSelector.vue?vue&type=script&lang=js"
export * from "./LoginSelector.vue?vue&type=script&lang=js"
import style0 from "./LoginSelector.vue?vue&type=style&index=0&id=48cebba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cebba2",
  null
  
)

export default component.exports